import { useCallback, useEffect, useState } from 'react';
import { useAsyncCallback } from 'hooks/useAsyncCallback';
import { getMaintenanceEngineDevices, MaintenanceEngineDevice } from 'services/maintenanceEngine';

export const useUpcomingMaintanenceInjection = () => {
  const [devices, setDevices] = useState<MaintenanceEngineDevice[]>([]);

  const handleGetData = useCallback(async () => {
    const resp = await getMaintenanceEngineDevices({ status: 'UPCOMING', page: 1, size: 99999 });
    setDevices(resp.devices);
  }, []);

  const { asyncCallback, isLoading: loading } = useAsyncCallback(handleGetData, []);

  useEffect(() => {
    asyncCallback();
  }, [asyncCallback]);

  return {
    devices,
    loading
  };
};
